import useRecentlyViewed from './useRecentlyViewed';

export { useRecentlyViewed };
